// extracted by mini-css-extract-plugin
export default {"colorTangelo":"#fc4c02","button":"button_button__hsxyw","button--dark":"button_button--dark__s2Ryn"};